import {Button, Modal} from 'react-bootstrap';
import React, {useEffect, useState} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {IAlbum} from '../../interfaces/PlayerModels';
import {useCreateAlbum} from '../../utils/api';
import AlbumFormUI, {AlbumFormData} from '@components/forms/AlbumFormUI';

const CreateAlbumModal = () => {
    const mutation = useCreateAlbum();
    const [show, setShow] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    // Form
    const form = useForm<AlbumFormData>({
        mode: 'onChange'
    });
    const {handleSubmit, formState} = form;

    const saveAlbum: SubmitHandler<AlbumFormData> = async (data) => {
        setSubmitError(false);

        try {
            // Clone the data and remove the ID from the request body.
            const albumData: Partial<IAlbum> = Object.assign({}, data);

            // Fire off the mutation to save the album.
            await mutation.mutateAsync({data: albumData});

            // Successfully created the album, close the modal.
            setShow(false);

            window.location.reload();
        } catch (e) {
            // There was an error saving the album, show an error message.
            setSubmitError(true);
        }
    };

    useEffect(() => {
        if (!show) {
            // When this component is about to hide itself, reset the form.
            form.reset();
            setSubmitError(false);
        }
    }, [form, show]);

    return (
        <>
            <Button onClick={() => setShow(true)}><i className={'bi bi-plus-circle'} title={'Edit'}/> Add new
                album</Button>
            <Modal size={'lg'} show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Create new album
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AlbumFormUI form={form}/>
                </Modal.Body>
                <Modal.Footer>
                    {submitError &&
                        <p className={'text-danger'}>There was an error creating the album. Please try again.</p>}
                    <Button variant="danger" onClick={() => setShow(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" disabled={!formState.isValid} onClick={handleSubmit(saveAlbum)}>
                        Create
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CreateAlbumModal;